import { render, staticRenderFns } from "./AboutTest.vue?vue&type=template&id=25d63af2"
import script from "./AboutTest.vue?vue&type=script&lang=js"
export * from "./AboutTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports